import axios from "./axios-handler.service";
const BASE_URL = "/api/Parceiros";
export interface Parceiro {
  idConsultor: number;
  nome: string;
  cpf: string;
  email: string;
  pix: string;
  saldoAtual: number;
  ehParceiro: boolean;
}
export class ParceirosService {
  static async obter(idParceiro: number): Promise<Parceiro> {
    const response = await axios.get<Parceiro>(`${BASE_URL}/Obter`, {
      params: {
        idParceiro,
      },
    });
    return response.data;
  }
  static async listarParceiros(
    txtPesquisa: string | null,
    saldoMaiorQue: number | null
  ): Promise<Parceiro[]> {
    const response = await axios.get<Parceiro[]>(
      `${BASE_URL}/ListarParceiros`,
      {
        params: {
          txtPesquisa: txtPesquisa || "",
          saldoMaiorQue: saldoMaiorQue || 0,
        },
      }
    );
    return response.data;
  }
  static async listarNaoParceiros(
    txtPesquisa: string | null
  ): Promise<Parceiro[]> {
    const response = await axios.get<Parceiro[]>(
      `${BASE_URL}/ListarNaoParceiros`,
      {
        params: {
          txtPesquisa: txtPesquisa || "",
        },
      }
    );
    return response.data;
  }
  static async associarParceiro(parceiro: Parceiro): Promise<Parceiro[]> {
    const response = await axios.post(`${BASE_URL}/AssociarParceiro`, parceiro);
    return response.data;
  }
  static async desassociarParceiro(parceiro: Parceiro): Promise<Parceiro[]> {
    const response = await axios.post(`${BASE_URL}/desassociarParceiro`, parceiro);
    return response.data;
  }
}
